import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';

import {FuseConfigService} from '../../../core/services/config.service';
import {AuthDataManager} from '../../../data/auth.datamanager';
import {ErrorResponse} from '../../../data/model/errorResponse';
import {UsersDataManager} from '../../../data/users.datamanager';

@Component({
  selector: 'fuse-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss']
})
export class TwoFactorComponent implements OnInit {
  setupResponse: any = null;
  verificationCode = '';
  disableCode = '';
  loading = false;
  pendingSetup = false;
  twoFactorEnabled = false;
  twoFactorForced = false;

  constructor(
      private fuseConfig: FuseConfigService,
      private authDataManager: AuthDataManager,
      private usersDataManager: UsersDataManager,
      private router: Router,
      private snackBar: MatSnackBar) {}

  ngOnInit() {
    if (!this.authDataManager.isLoggedIn()) {
      this.router.navigate(['/login']);
      return;
    }

    this.refreshState();

    if (this.pendingSetup || !this.twoFactorEnabled) {
      this.startSetup();
    }
  }

  getQrCodeUrl() {
    if (!this.setupResponse || !this.setupResponse.otpauth_url) {
      return '';
    }

    return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' +
        encodeURIComponent(this.setupResponse.otpauth_url);
  }

  startSetup() {
    this.loading = true;
    this.authDataManager.setupTwoFactor().subscribe(
        (response) => {
          this.setupResponse = response;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.showError(err);
        });
  }

  enableTwoFactor() {
    if (!this.verificationCode) {
      return;
    }

    this.loading = true;
    this.authDataManager.enableTwoFactor(this.verificationCode).subscribe(
        (response) => {
          this.authDataManager.setLogin(response);
          this.verificationCode = '';
          this.setupResponse = null;
          this.refreshState();
          this.loading = false;
          this.showMessage('Two-factor authentication enabled.');

          if (!this.pendingSetup) {
            return;
          }

          this.completeProfileAndContinue();
        },
        (err) => {
          this.loading = false;
          this.showError(err);
        });
  }

  disableTwoFactor() {
    if (!this.disableCode) {
      return;
    }

    this.loading = true;
    this.authDataManager.disableTwoFactor(this.disableCode).subscribe(
        (response) => {
          this.authDataManager.setLogin(response);
          this.disableCode = '';
          this.refreshState();
          this.loading = false;
          this.showMessage('Two-factor authentication disabled.');
        },
        (err) => {
          this.loading = false;
          this.showError(err);
        });
  }

  private completeProfileAndContinue() {
    this.usersDataManager.getLoggedInUser().subscribe(
        (user) => {
          this.usersDataManager.setRole(user.role);
          this.usersDataManager.setName(user.name);
          this.usersDataManager.setOrganisation(user.organisation);
          this.router.navigate(['/users']);
        },
        (err) => {
          this.showError(err.json ? err.json() : err);
        });
  }

  private refreshState() {
    this.pendingSetup = this.authDataManager.requiresTwoFactorSetup();
    this.twoFactorEnabled = this.authDataManager.isTwoFactorEnabled();
    this.twoFactorForced = this.authDataManager.isTwoFactorForced();
    this.applyLayout();
  }

  private applyLayout() {
    this.fuseConfig.setSettings({
      layout: {
        navigation: this.pendingSetup ? 'none' : 'left',
        toolbar: 'below',
        footer: 'none'
      }
    });
  }

  showMessage(message: string) {
    this.snackBar.open(message, null, {duration: 5000});
  }

  showError(message: any) {
    const parsedMessage = this.getErrorMessage(message);
    this.snackBar.open(parsedMessage, null, {duration: 10000});
  }

  private getErrorMessage(message: any) {
    if (message && message.errors && message.errors.length > 0) {
      return message.errors[0].message;
    }

    if (message && message.json) {
      try {
        const body = message.json();
        if (body && body.errors && body.errors.length > 0) {
          return body.errors[0].message;
        }
      } catch (e) {
      }
    }

    return 'Unable to verify the 2FA code.';
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/two-factor/two-factor.component.ts